import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { switchMap, map, catchError, of } from "rxjs";
import { MarketingAutomationClient } from "src/api-service";
import { normalizeError } from "../../../../app-store-error.types";
import { EmailLogsActions } from "./email-logs.actions";

@Injectable()
export class EmailLogsEffects {
    private readonly actions$ = inject(Actions);
    private readonly marketingAutomationClient = inject(MarketingAutomationClient);

    loadEmailLogs$ = createEffect(() =>
        this.actions$.pipe(
            ofType(EmailLogsActions.load),
            switchMap(() =>
                this.marketingAutomationClient.getEmailLogs().pipe(
                    map(logs => EmailLogsActions.loadSuccess({ logs })),
                    catchError(error =>
                        of(
                            EmailLogsActions.loadFailure({
                                error: normalizeError(error),
                                toastKey: "DEVELOPER.SENT_EMAILS.LOAD_ERROR",
                            }),
                        ),
                    ),
                ),
            ),
        ),
    );
}
